import { NavItem } from '@/interfaces';
import { Component, Mixins } from 'vue-property-decorator';
import PrivilegeMixin from './PrivilegeMixin';

@Component
export default class NavBarMixin extends Mixins(PrivilegeMixin) {
  // Based on legacy system
  public get navItems() {
    const navItems: NavItem[] = [];
    // BEHEER
    if (this.roleCheck('pr_manage', 'Read')) {
      navItems.push({
        name: 'Beheer',
        url: '/manage',
        menuItems: [
          { name: 'Groepen', url: '/groups' },
          { name: 'Gebruikers', url: '/users' },
          { name: 'Logging', url: '/logging' }
        ]
      });
    }
    // REFERENTIES
    if (this.roleCheck('pr_reference', 'Read')) {
      const referenceNavItem: NavItem = {
        name: 'Referenties',
        url: '/references',
        menuItems: []
      };
      if (this.roleCheck('pr_reference', 'Manage')) {
        referenceNavItem.menuItems.push(
          { name: 'Fabrikanten', url: '/suppliers' },
          { name: 'Adressen', url: '/addresses' },
          { name: 'Servers', url: '/servers' },
          {
            name: 'Interventiepersonen',
            url: '/interventionpersons'
          },
          {
            name: 'Verantwoordelijken',
            url: '/responsibles'
          },
          {
            name: 'Projectleiders',
            url: '/projectmanagers'
          },
          { name: 'Groepen', url: '/groups' }
        );
      }
      referenceNavItem.menuItems.push({
        name: 'Toezichters',
        url: '/supervisors'
      });
      if (this.roleCheck('pr_reference', 'Manage')) {
        referenceNavItem.menuItems.push({
          name: 'Documenten',
          url: '/documents'
        });
      }
      navItems.push(referenceNavItem);
    }
    // CAMERAS
    if (this.roleCheck('pr_device', 'Read')) {
      const deviceNavItem: NavItem = {
        // tslint:disable-next-line: quotemark
        name: "Camera's RLC/SNC of andere",
        url: '/devices',
        menuItems: []
      };
      if (this.roleCheck('pr_device', 'Manage')) {
        deviceNavItem.menuItems.push(
          { name: 'Types', url: '/types' },
          { name: 'Testen', url: '/tests' },
          { name: 'Goedkeuringsnummers', url: '/approvalnumbers' }
        );
      }
      deviceNavItem.menuItems.push(
        { name: 'Meettoestellen', url: '/measuredevices' },
        { name: 'Meetrapporten', url: '/measurereports' },
        { name: 'Bestanden', url: '/files' },
        {
          name: 'Onderhoudsverslagen',
          url: '/servicereports'
        }
      );
      if (this.roleCheck('pr_device', 'Manage')) {
        deviceNavItem.menuItems.push(
          { name: 'Layout Certificaten', url: '/certificatelayouts' },
          { name: 'Layout Rapporten', url: '/reportlayouts' },
          { name: 'Layout Export', url: '/exportlayouts' }
        );
      }
      if (this.roleCheck('pr_device', 'Write') || this.isEMT()) {
        deviceNavItem.menuItems.push({
          name: 'Status Aanpassingen',
          url: '/statusupdates'
        });
      }
      navItems.push(deviceNavItem);
    }
    // SITES
    if (this.roleCheck('pr_site', 'Read')) {
      const siteNavItem: NavItem = {
        name: 'Sites',
        url: '/sites',
        menuItems: []
      };
      if (this.roleCheck('pr_site', 'Manage')) {
        siteNavItem.menuItems.push(
          { name: 'Types', url: '/types' },
          { name: 'Rapport Types', url: '/reporttypes' }
        );
      }
      siteNavItem.menuItems.push(
        { name: 'Sites', url: '/sites' },
        { name: 'Rapporten', url: '/reports' },
        { name: 'Bestanden', url: '/files' },
        { name: 'Planning', url: '/planning' }
      );
      if (this.roleCheck('pr_site', 'Manage')) {
        siteNavItem.menuItems.push({
          name: 'Layout Export',
          url: '/exportlayouts'
        });
      }
      if (this.roleCheck('pr_site', 'Write') || this.isEMT()) {
        siteNavItem.menuItems.push({
          name: 'Status Aanpassingen',
          url: '/statusupdates'
        });
      }
      if (this.roleCheck('pr_site_service_order', 'Read')) {
        siteNavItem.menuItems.push({
          name: 'Dienstbevelen',
          url: '/serviceorders'
        });
      }
      if (this.roleCheck('pr_site_notification', 'Read')) {
        siteNavItem.menuItems.push({
          name: 'Meldingen',
          url: '/notifications'
        });
      }
      navItems.push(siteNavItem);
    }
    // TRAJECT CONTROLES
    if (this.roleCheck('pr_tc', 'Read')) {
      const tcNavItem: NavItem = {
        name: 'Traject Controles',
        url: '/routecontrols',
        menuItems: []
      };
      if (this.roleCheck('pr_tc', 'Manage')) {
        tcNavItem.menuItems.push(
          { name: 'Types', url: '/types' },
          { name: 'Rapport Types', url: '/reporttypes' }
        );
      }
      tcNavItem.menuItems.push(
        { name: 'Traject Controles', url: '/routecontrols' },
        { name: 'Rapporten', url: '/reports' },
        { name: 'Bestanden', url: '/files' },
        { name: 'Planning', url: '/planning' }
      );
      if (this.roleCheck('pr_tc', 'Manage')) {
        tcNavItem.menuItems.push({
          name: 'Layout Export',
          url: '/exportlayouts'
        });
      }
      if (this.roleCheck('pr_tc', 'Write') || this.isEMT()) {
        tcNavItem.menuItems.push({
          name: 'Status Aanpassingen',
          url: '/statusupdates'
        });
      }
      if (this.roleCheck('pr_tc_service_order', 'Read')) {
        tcNavItem.menuItems.push({
          name: 'Dienstbevelen',
          url: '/serviceorders'
        });
      }
      if (this.roleCheck('pr_tc_notification', 'Read')) {
        tcNavItem.menuItems.push({
          name: 'Meldingen',
          url: '/notifications'
        });
      }
      navItems.push(tcNavItem);
    }
    return navItems;
  }
}
